import { memo, useCallback } from "react";
import { Link } from "../../../Link";

import { ReactComponent as Icon } from "./icons/bulk.svg";

type BulkOpsProps = {
  setIsBulkOpsEnabled: (v: boolean) => void,
  isBulkOpsEnabled: boolean,
  isVisible: boolean
}

const BulkOps = memo<BulkOpsProps>(({ setIsBulkOpsEnabled, isBulkOpsEnabled, isVisible }) => {
  const onClick = useCallback(
    () => setIsBulkOpsEnabled(!isBulkOpsEnabled),
    [ setIsBulkOpsEnabled, isBulkOpsEnabled ],
  );
  return isVisible ? (
    <Link
      component="button"
      type="button"
      linkType="s"
      onClick={onClick}
    >
      <Icon width={15} height={15} />Bulk actions
    </Link>
  ) : null;
});

export default BulkOps;
